import styles from "./OrderDetail.module.css"
import chevronLeft from "../../asset/icons/chevronLeft.png";
import forward from "../../asset/icons/whiteForwardCircle.png"
import whatsappIcon from "../../asset/icons/whatsapp.png"
import { ErrorFallback } from "../../components/Error/Error";
import { Loading } from "../../components/Loading/Loading";
import Api from "../../utils/Api/Api";
import React, { useState, useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { trackCustomEvent, CUSTOM_EVENTS } from '../../utils/analyticsService';
import Helper from "../../utils/Helper";

import { ProductPurchaseCard ,SubscriptionCouponDetailsCard , YoutubeLinkCard ,
    PaymentDetailsCard ,PaymentInstrumentDetailsCard} from "../../components";

export const OrderDetail = ()=>{
    const { order_id } = useParams();
    // console.log('Order ID:', order_id);

    const [loading,setLoading] = useState(true);
    const [hasError,setError] = useState(false);
    const [orderDetail,setOrderDetail] = useState([]);
    const navigate = useNavigate()

    useEffect(()=>{
        const fetchCartData = async ()=>{
            try {
                // console.log('Fetching order details...');
                let { data } = await Api.GetOrderDetails(order_id);
                // console.log('Order details response:', data);
                setOrderDetail(data);

                // Use centralized analytics for order detail view
                if (data) {
                    trackCustomEvent(CUSTOM_EVENTS.CONTENT_VIEWED, {
                        content_type: 'order_detail',
                        order_id: data.representation_id,
                        value: data.payment?.amount || 0,
                        currency: data.details?.currency_type || 'INR',
                        status: data.status,
                        payment_method: data.payment?.payment_method,
                        product_name: data.subscription_plan?.plan_name,
                        product_id: data.subscription_plan?.subscription_plan_id,
                        fleek_coins_used: data.details?.coin_value_used || 0
                    });
                }
            }
            catch(err) {
                // console.error('Error fetching order details:', err);
                setError(true);
            }
            setLoading(false)
        }
        fetchCartData();
    },[order_id])

    if(hasError) {
        return <ErrorFallback />
    }
    if(loading) {
        return <Loading />
    }

    // console.log('Full orderDetail:', orderDetail);

    const { payment, youtube_url, subscription_plan: {code_redemption_url, mrp_price} = {}, cost, updated_at, 
    product_digital, status = 'Order Placed', details, is_deep_tech, representation_id } = orderDetail;

    // console.log('Before rendering SubscriptionCouponDetailsCard:', {
    //     product_digital,
    //     is_deep_tech,
    //     orderDetail: {
    //         coupon_code: orderDetail.coupon_code,
    //         code_copied: orderDetail.code_copied,
    //         code_redeemed: orderDetail.code_redeemed,
    //         is_activation_pending: orderDetail.is_activation_pending,
    //         post_payment_activation_message: orderDetail.post_payment_activation_message
    //     }
    // });

    const paymentDetailsCard = {
        mrp_price,
        effective_cost: payment?.amount, 
        cost: cost - (cost - payment?.amount - details?.coin_value_used),
        coin_value_reserved: details?.coin_value_used,
        useFleekCoin: details?.coin_value_used,
        actual_discounted_cost: payment?.amount,
    }

    let date = Helper.dateFormat(updated_at);

    const openWhatsApp = () => {
        window.open(`https://wa.me/919148477518`, '_blank');
    }

    return(
        <>
            <Helmet>
                <script>
                    {`
                        fbq('track', 'ViewOrderDetails', {
                            order_id: '${orderDetail?.representation_id || ""}',
                            value: ${payment?.amount || 0},
                            currency: '${details?.currency_type || "INR"}',
                            status: '${status || ""}',
                            product_name: '${orderDetail?.subscription_plan?.plan_name || ""}'
                        });
                    `}
                </script>
            </Helmet>
            <div className={styles.headcontent}>
            </div>
            <div className={styles.content}>
                <div className={styles.header}>
                    <img onClick={() => navigate('/myorder')} className={styles.chevronLeft} src={chevronLeft} alt="chevronLeft"/>
                    <p className={styles.headText}>Order details</p>
                    <p onClick={() =>  navigate('/support')} className={styles.helpText}>HELP</p>
                </div>
                <div className={styles.detailContainer}>
                    <div className={styles.cardContainer}>
                        <ProductPurchaseCard cartData={orderDetail} orderPage={true} />
                        {product_digital && (
                            <React.Fragment>
                                {console.log('Rendering SubscriptionCouponDetailsCard with:', {
                                    orderDetail,
                                    is_deep_tech
                                })}
                                <SubscriptionCouponDetailsCard 
                                    orderDetail={orderDetail} 
                                    is_deep_tech={is_deep_tech}
                                />
                            </React.Fragment>
                        )}
                        {youtube_url && <YoutubeLinkCard youtube_url={youtube_url}/>}
                        {product_digital && !is_deep_tech && <div className={styles.mobileButtonContainer}>
                            <button onClick={() => window.open(code_redemption_url, '_blank', 'noopener,noreferrer')} className={styles.nextButton}>
                                ACTIVATE NOW
                                <img className={styles.forward} alt="forward" src={forward}/>
                            </button>
                        </div>}
                    </div> 
                    <div className={styles.otherDetail}>
                        <div className={styles.orderDetail}>
                            <p className={styles.orderId}>Order ID: {representation_id}</p>
                            <p className={styles.orderPlaceText}>{status}</p>
                            <p className={styles.date}>on {date}</p>
                        </div>
                        
                        <div className={styles.whatsappCard} onClick={openWhatsApp}>
                            <div className={styles.whatsappContent}>
                                <img src={whatsappIcon} alt="WhatsApp" className={styles.whatsappIcon} />
                                <div className={styles.whatsappText}>
                                    <p className={styles.whatsappTitle}>Need support?</p>
                                    <p className={styles.whatsappSubtitle}>WhatsApp us now</p>
                                    <p className={styles.whatsappNumber}>+91 91484 77518</p>
                                </div>
                            </div>
                            <img src={forward} alt="forward" className={styles.whatsappForward}/>
                        </div>

                        <PaymentDetailsCard cartData={paymentDetailsCard} useFleekCoin={paymentDetailsCard.useFleekCoin}/>
                        {payment && <PaymentInstrumentDetailsCard payment = {payment} />}
                    </div>
                </div>       
            </div>     
        </>
    )
}